/**
 * Detects if a URL parameter string indicates a Bing campaign variant.
 *
 * In the legacy Gatsby implementation, Bing variants are identified by the `p_ref`
 * URL parameter containing specific Bing-related identifiers.
 *
 * Common Bing variant patterns in p_ref:
 * - Contains 'cpc_bing' or 'cpc_ms' (Bing CPC campaigns)
 * - Contains '_bing_' anywhere in the string
 * - Contains 'msn' (Microsoft Network campaigns)
 *
 * @param pref - The p_ref URL parameter value (e.g., 'cpc_bing_pid_123_campaign_name')
 * @returns True if the p_ref indicates a Bing campaign variant
 *
 * @example
 * isBingVariant('cpc_bing_pid_123_fotobuch'); // true
 * isBingVariant('cpc_gg_pid_456_fotobuch');   // false (Google)
 * isBingVariant('cpc_ms_brand_campaign');     // true
 */
export function isBingVariant(pref?: string | null): boolean {
  if (!pref) {
    return false;
  }

  const lowerPref = pref.toLowerCase();

  // Check for Bing/Microsoft identifiers
  const bingIdentifiers = ['cpc_bing', 'cpc_ms', '_bing_', 'msn'];

  return bingIdentifiers.some((identifier) => lowerPref.includes(identifier));
}
